<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="margin-top: 10px;display: flex">
      <el-select v-model="year" style="width: 150px;" @change="initData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="month" style="width: 150px;margin-left: 10px;" @change="initData">
        <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
      </el-select>
    </div>

    <div  v-for="(item,index) in kpiList">
      <div style="display: flex;margin-top: 10px">
        <div style="width: 250px;line-height: 35px;margin-bottom: 10px"><b>{{index + 1}}. {{item.kpiName}}：</b></div>
        <el-select v-model="item.sortType" style="width: 200px;" @change="renderEcharts(item)">
          <el-option label="销量排序" value="salesCntSort" key="salesCntSort"></el-option>
          <el-option label="完成度排序" value="completionSort" key="completionSort"></el-option>
          <el-option label="KPI排序" value="kpiSort" key="kpiSort"></el-option>
        </el-select>
      </div>

      <div style="width: 100%;height: 300px;margin-top: 10px" :id="item.kpiName + index"></div>
    </div>




  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "DataSort",

  data(){
    return {
      year:'',
      yearList:[],
      month:1,
      kpiList:[],
      first:true,

    }
  },

  async created() {
    await this.getYearList();
    await this.initData();


  },
  methods:{
    async initData(){
      await this.getKpiData();
      await this.getEChart();
    },

    async getYearList(){
      const now = dayjs();
      this.year = now.year() +'';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },

    async getKpiData(){
      let params = {year:this.year,month:this.month}
      let dataList = await this.$http('crmEmployeeService.getDataSort', params);
      if(!dataList){
        return;
      }
      this.kpiList = dataList;
    },
    async getEChart(){
      if(this.kpiList.length === 0){
        return;
      }
      for (let data of this.kpiList){
        let idx = this.kpiList.indexOf(data);
        data.elementId = data.kpiName + idx;
        if(this.first){
          data.sortType = 'salesCntSort';
        }
        await this.renderEcharts(data);
      }
      this.first = false;
    },

    async renderEcharts(item) {
      if(!item.elementId){
        return;
      }
      let data;
      if(item.sortType === 'salesCntSort'){
        data = item.salesSort
      }
      if(item.sortType === 'completionSort'){
        data = item.completeSort

      }
      if(item.sortType === 'kpiSort'){
        data = item.kpiSort
      }
      const chartDom = document.getElementById(item.elementId);
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(chartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(chartDom);
      myChart.setOption(this.getChartOptions(data), true);
    },

    getChartOptions(data){
      return {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let tooltipHtml = '';
            // 获取 X 轴数据（假设 params[0] 存在）
            const xAxisValue = params[0].axisValue; // X 轴的值，例如 "1月"
            tooltipHtml += `<b>${xAxisValue}</b><br>`; // 第一行显示 X 轴数据

            params.forEach(param => {
              if (param.seriesType === 'line') {
                tooltipHtml += `${param.marker} ${param.seriesName}<span style="float: right;margin-left: 10px"><b>${param.value}%</b></span><br>`;
              } else if (param.seriesType === 'bar') {
                tooltipHtml += `${param.marker} ${param.seriesName}<span style="float: right;margin-left: 10px"><b>${param.value}</b></span><br>`;
              }
            });
            return tooltipHtml;
          }
        },
        legend: {
          data: ['KPI(套)', '销量(套)', '完成度(%)']
        },
        xAxis: [
          {
            type: 'category',
            data: data.xData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '套数',
            alignTicks:true
          },
          {
            type: 'value',
            name: '完成度(%)',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
      ],
        series: data.seriesData,
      }
    }

  }

}
</script>

<style scoped>

</style>